import Decimal from 'decimal.js';

const number = value => new Intl.NumberFormat('id-ID', { maximumFractionDigits: 8 }).format(Number(value));

// Presentation only: stock and unit conversion values remain untouched.
export function stockDisplay(product, { detailed = false } = {}) {
  const raw = product.stock;
  if (raw == null || raw === '' || !Number.isFinite(Number(raw))) return '—';
  const stock = new Decimal(raw);
  if (stock.isZero()) return 'Habis';
  const units = (Array.isArray(product.units) ? product.units : []).filter(unit =>
    unit && typeof unit.name === 'string' && unit.name.trim() && Number.isFinite(Number(unit.pieces)) && Number(unit.pieces) > 0);
  const base = units.find(unit => Number(unit.pieces) === 1)?.name.trim() || String(product.base_unit || '').trim();
  const baseText = value => `${number(value)}${detailed && base ? ` ${base}` : ''}`;
  if (stock.isNegative() || !base) return baseText(stock);
  const pack = units.filter(unit => Number(unit.pieces) > 1)
    .reduce((largest, unit) => !largest || Number(unit.pieces) > Number(largest.pieces) ? unit : largest, null);
  if (!pack) return baseText(stock);
  const count = stock.dividedToIntegerBy(pack.pieces);
  const remainder = stock.minus(count.times(pack.pieces));
  return detailed
    ? `${baseText(remainder)} · ${number(count)} ${pack.name.trim()}`
    : `${number(remainder)}/${number(count)}`;
}
